import Vue from 'vue';
import CSelect from '@/components/ui/CSelect';
import CTextField from '@/components/ui/CTextField';
import CCheckbox from '@/components/ui/CCheckbox';
import CAutocomplete from '@/components/ui/CAutocomplete';
import CTextArea from '@/components/ui/CTextArea';
import CPage from '@/components/ui/CPage';
import CError from '@/components/ui/CError';

Vue.component('CSelect', CSelect);
Vue.component('CTextField', CTextField);
Vue.component('CCheckbox', CCheckbox);
Vue.component('CAutocomplete', CAutocomplete);
Vue.component('CTextarea', CTextArea);
Vue.component('CPage', CPage);
Vue.component('CError', CError);
